import { Route, Routes } from "react-router-dom";

import IdleTimerComponent from "../components/IdleTimerComponent";
import Layout from "../components/Layout/Layout";

import SettingsPage from "../pages/Settings/SettingsPage";

const AdminNavigator = () => {
  return (
    <>
      <IdleTimerComponent />

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<SettingsPage />} />
          <Route path="/Settings" element={<SettingsPage />} />
          <Route path="*" element={<SettingsPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default AdminNavigator;
